import Styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

export const ShippingSection = Styled.div`
  margin-top: 32px;
`;

export const ShippingTitle = Styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #1D1D1F;
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const ShippingBox = Styled.div`
  background-color: #F5F5F7;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ShippingBoxError = Styled.div`
  background-color: #FDEBEC;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ShippingInfoRow = Styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ShippingInfoText = Styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #1D1D1F;
  line-height: 1.5;
  flex: 1;
`;

export const ShippingText = Styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #1D1D1F;
  line-height: 1.5;
`;

export const ShippingAddress = Styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #1D1D1F;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const ChangeAddressLink = Styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 16px;
  font-size: 17px;
  font-weight: 400;
  color: #1D1D1F;
  text-decoration: underline;
  cursor: pointer;
  font-family: var(--font-family);
`;

export const ReloadButton = Styled.button`
  background: none;
  border: none;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  color: #1D1D1F;
  cursor: pointer;
  font-family: var(--font-family);
`;

export const SkeletonLine = Styled.div`
  height: ${(p) => p.h || "16px"};
  width: ${(p) => p.w || "100%"};
  border-radius: 4px;
  background: #E5E5EA linear-gradient(
    90deg,
    rgba(229, 229, 234, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(229, 229, 234, 0) 100%
  ) no-repeat;
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;

export const PrimaryButton = Styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 9px;
  background-color: var(--button-primary-color, #1D1D1F);
  color: var(--button-secondary-color, #FFFFFF);
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 16px;
  font-family: var(--font-family);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
